var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-message",class:_vm.color},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"circle-wrap mr-2"},[_c('Icon',{attrs:{"name":_vm.icon,"width":"16"}})],1),_c('span',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }